export const getPhoneWithoutUSCode = phone =>
  phone ? phone.replace('+1', '') : '';



// WEBPACK FOOTER //
// ./src/utils/getPhone.js